import { setLocale as umiSetLocale, history } from 'umi';
import _localeMaps from './maps';

type AVAILABLE_KEY = keyof typeof _localeMaps;
type LOCALE_PKG = Record<string, string>;
type AVAILABLE_ID = string;
interface OPTIONS {
  values?: Record<string, any>;
}

const getQueryLocale = () => history.location.query?.locale as AVAILABLE_KEY;
const getPathName = () => history.location.pathname;
const getBrowserLocale = () => (typeof navigator === 'undefined' ? 'en-US' : navigator.language);
const getLanguageLocale = () => getQueryLocale() || getBrowserLocale();

class Locale {
  private localeMaps: Record<AVAILABLE_KEY, LOCALE_PKG> = _localeMaps;

  private localePkg: LOCALE_PKG = this.localeMaps['en-US'];

  constructor() {
    const locale = this.getLocale();
    this.localePkg = this.localeMaps[locale];
    umiSetLocale(locale, false);
  }

  setLocale: (locale: AVAILABLE_KEY, realReload: boolean) => void = (locale, realReload) => {
    if (getQueryLocale()) {
      history.replace(getPathName());
    }
    umiSetLocale(locale, realReload);
  };

  getLocale: (locale?: string) => AVAILABLE_KEY = (locale = getLanguageLocale()) => {
    const l = locale.toLowerCase();
    const fallbackMap = [
      { key: 'zh-TW', is: () => ['zh-tw', 'zh-hk', 'zh-mo'].includes(l) },
      { key: 'zh-CN', is: () => l.startsWith('zh-') || l === 'zh' },
      { key: 'es-ES', is: () => l.startsWith('es-') || l === 'es' },
      { key: 'en-US', is: () => true },
    ];
    return (fallbackMap.find(_ => _.is()) as { key: string }).key as AVAILABLE_KEY;
  };

  private translateStr: (id: string, options?: OPTIONS) => string = (id, options = {}) => {
    const { values = {} } = options;
    let str = this.localePkg[id] || id;
    Object.keys(values).forEach(key => {
      const keyword = `\\\${${key}}`;
      str = str.replace(new RegExp(keyword, 'g'), values[key]);
    });
    return str;
  };

  s: (id: AVAILABLE_ID, options?: OPTIONS) => AVAILABLE_ID = (id, options) => this.translateStr(id, options);
}

const localeInstance = new Locale();

const getLocale = localeInstance.getLocale.bind(localeInstance);
const setLocale = localeInstance.setLocale.bind(localeInstance);
const s = localeInstance.s.bind(localeInstance);

export { getLocale, setLocale, s };
